import React, { useState } from "react";
import { Typography } from "antd";
import { LuFileText, LuImage, LuVideo } from "react-icons/lu";
import { MEDIA_TYPE, getMediaTypeLabel } from "../activityCenter/mediaTrackingHelpers";

const { Text } = Typography;

const MEDIA_ICON_MAP = {
  [MEDIA_TYPE.IMAGE]: LuImage,
  [MEDIA_TYPE.VIDEO]: LuVideo,
  [MEDIA_TYPE.DOC]: LuFileText,
};

const Thumbnail = ({ src }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <span className="relative inline-block w-8 h-8 rounded overflow-hidden flex-shrink-0">
      {!loaded && <span className="absolute inset-0 bg-gray-100 animate-pulse" />}
      {/* eslint-disable-next-line jsx-a11y/alt-text */}
      <img
        src={src}
        width={32}
        height={32}
        decoding="async"
        fetchPriority="low"
        alt=""
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)}
        className="absolute inset-0 w-full h-full object-cover"
      />
    </span>
  );
};

// `onThumbnailClick` / `onLabelClick` (optional) make the media thumbnail and
// the name independently clickable — e.g. thumbnail → preview, name → open in
// activity center. When omitted, the element renders as plain (non-clickable).
const MediaLabel = ({ type, thumbnail, count, label, onThumbnailClick, onLabelClick }) => {
  const IconComponent = MEDIA_ICON_MAP[type];

  const visual = thumbnail ? (
    <Thumbnail src={thumbnail} />
  ) : (
    IconComponent && (
      <div className="flex items-center justify-center w-8 h-8 rounded bg-gray-50 text-gray-400 flex-shrink-0">
        <IconComponent size={18} />
      </div>
    )
  );

  return (
    <span className="flex items-center gap-2">
      {onThumbnailClick ? (
        <span
          title="Preview media"
          className="cursor-pointer inline-flex flex-shrink-0"
          onClick={onThumbnailClick}
        >
          {visual}
        </span>
      ) : (
        visual
      )}
      <Text
        className={`!text-sm whitespace-nowrap${onLabelClick ? " cursor-pointer" : ""}`}
        onClick={onLabelClick}
      >
        {label || getMediaTypeLabel(type, count)}
      </Text>
    </span>
  );
};

export default React.memo(MediaLabel);
